<script setup lang="ts">
defineProps<{
  event: EventCard;
  titleTag: "h1" | "h2" | "h3";
}>();
</script>

<template>
  <a
    v-if="event.eventType === 'conferance' && event.website"
    :href="event.website"
    target="_blank"
    class="no-underline"
    aria-label="Gå til arrangementets eksterne side"
  >
    <CardsEventContent :event="event" :title-tag="titleTag" />
  </a>
  <NuxtLink
    v-else
    :to="event.slug.full"
    class="no-underline"
  >
    <CardsEventContent :event="event" :title-tag="titleTag" />
  </NuxtLink>
</template>
